import * as firebase from 'firebase';
import 'firebase/firestore';


const config = {
  apiKey: "AIzaSyDg5bnojXqmeBHOD0USGcvrRfynG9hLmz0",
  authDomain: "bookkurry-app.firebaseapp.com",
  databaseURL: "https://bookkurry-app.firebaseio.com",
  projectId: "bookkurry-app",
  storageBucket: "bookkurry-app.appspot.com",
  messagingSenderId: "762975843705"
}
//
//const fb = firebase.initializeApp(config)
let app = firebase.initializeApp(config);

export const isProduction = false
export const basename = '/d2hengine'
export const firebaseStorageBookCoverFolder = 'cover_url'
export const firebaseStorageBookZipFolder = 'book_download_url'
export const realtimeDb = firebase.database().ref()
export const firebaseAuth = firebase.auth
export const firestoreDb = firebase.firestore(app)
export const storageRef = firebase.storage().ref()



// WEBPACK FOOTER //
// ./src/config/constants.js